import { 
    // setToken, 
    removeToken 
} from '@/utils/auth'
import {
    checkEmail, validateMobile, getFaceIdentify,
    sendPhoneCode,
    sendEmailCode,
    fetchCountry,
    fetchProvince,
    fetchCity,
    uploadImageByBaseStr
  } from '@/api/index'

const registerMixin = {
    data() {
        return {
            cLoading: false,
            pLoading: false,
            cityLoading: false
        }
    },
    methods: {
        getSumbitParams(params, fields) {
            let options = {}
            Object.keys(params).forEach(key => {
               if (fields[key] || ['countryCode', 'editMobile', 'editEmail', 'validateCode', 'corporateCountryId', 'countryHeadQuaterId'].includes(key) === true) {
                options[key] = params[key]
               } 
            })
            return options
        },
        goPrev() {
            if(this.loginAccount.indexOf('@')!=-1) {
                //手机
                this.$router.replace({ path: '/l-register/account-mobile-info/0' })
            }else {
                //邮箱
                this.$router.replace({ path: '/l-register/account-email-info/0' })
            }
        },
        // 返回首页
        backHome() {
            removeToken()
            this.$router.replace({ path: '/' })
        },
        // 把国家，省份，城市的字段转换一下
        changeField(field) {
            let t = ''
            switch (field) {
                case 'countryName':
                t = 'countryId'
                break
                case 'provinceName':
                t = 'provinceId'
                break
                case 'cityName':
                t = 'cityId'
                break
            }
            return t
        },
        // 获取国家
        getCountry() {
            this.cLoading = true
            fetchCountry({}).then(res => {
                if (res.data.code == '1000') {
                this.gOption = this.unique5(res.data.data)
                }
            }).finally(() => {
                this.cLoading = false
            })
        },
        //公司所在国切换
        changeCountry2(value){
            window.PC.findItem(
                () => {
                return this.gOption
                },
                'id',
                value,
                'phoneCode',
                val => {
                    this.$set(this.inputVal, 'cCode', parseInt(val))
                }
            )
        },
        //总部切换
        changeCountryQH(value){
            window.PC.findItem(
                () => {
                return this.gOption
                },
                'id',
                value,
                'phoneCode',
                val => {
                this.inputVal.HQCode = parseInt(val)
                }
            )
        },
        // 国家 change
        changeCountry(value) {
            if (value == '86') {
                this.idTypeOption = this.$t('select.idTypeOptions')
            } else if (value == '852') {
                this.idTypeOption = this.$t('select.idTypeOptionsHK')
            }  else if (value == '853') {
                this.idTypeOption = this.$t('select.idTypeOptionsMO')
            }  else if (value == '886') {
                this.idTypeOption = this.$t('select.idTypeOptionsTWN')
            } else {
                this.idTypeOption = this.$t('select.idTypeOptionsEN')
            }
            window.PC.findItem(
                () => {
                return this.gOption
                },
                'id',
                value,
                'phoneCode',
                val => {
                this.inputVal.faxCode = parseInt(val)
                }
            )
            this.$set(this.inputVal, 'idType', '')
            this.$set(this.inputVal, 'faxCode1', '')
            this.$set(this.inputVal, 'provinceId', '')
            this.$set(this.inputVal, 'cityId', '')
            this.getProvince(value)
        },
        // 获取省份
        getProvince(value) {
            this.pLoading = true
            fetchProvince({ countryId: value }).then(res => {
                if (res.data.code == '1000') {
                this.pOption = res.data.data
                }
            }).finally(() => {
                this.pLoading = false
            })
        },
        // 省份 change
        changeProvince(value) {
            this.$set(this.inputVal, 'faxCode1', '')
            this.$set(this.inputVal, 'cityId', '')
            this.getCity(value)
        },
        // 获取 城市
        getCity(value) {
            this.cityLoading = true
            fetchCity({ provinceId: value }).then(res => {
                if (res.data.code == '1000') {
                this.cOption = res.data.data
                }
            }).finally(() => {
                this.cityLoading = false
            })
        },
        // 城市 change
        changeCity(param) {
            window.PC.findItem(
                () => {
                return this.cOption
                },
                'id',
                param,
                'phoneCode',
                val => {
                this.inputVal.faxCode1 = val
                }
            )
            this.$forceUpdate()
        },
        // 去重
        unique5(arr) {
            let a = []
            let b = []
            arr.forEach(item => {
                if (a.indexOf(item.id) == -1) {
                a.push(item.id)
                b.push(item)
                }
            })
            return b
        },
        loadImgCommon(req, fn) {
            var _this = this
            if (req.file.size > _this.maxImgSize) {
                _this.$notify.error({
                message: _this.$t('Uploaded image can not greater than 1Mb')
                })
                return ''
            }
            const reader = new FileReader()
            reader.readAsDataURL(req.file)
            reader.onload = function() {
                let params = {
                    bucketName: 'ef-imaster-file',
                    objectName: window.PC.FileNameTimeStamp(req.file['name']),
                    baseStr: reader.result.split(',')[1],
                    bizType: 'IMAGEFILE'
                }
                fn && fn(params)
            }
        },
        //上传登记证
        loadRegistrationImg(req) {
            var _this = this
            _this.loadImgCommon(req, (params) => {
                _this.imgLoadingRegistration = true
                uploadImageByBaseStr(params)
                    .then(res => {
                        _this.inputVal.registration = res.data.data
                    })
                    .finally(() => {
                        _this.imgLoadingRegistration = false
                    })
            })
        },
        // 图片上传
        loadImg(req) {
            var _this = this
            _this.loadImgCommon(req, (params) => {
                _this.imgLoading = true
                uploadImageByBaseStr(params)
                    .then(res => {
                        if (_this.isFace) {
                            let img = res.data.data
                            let data = {
                                imgUrl: res.data.data
                            }
                            getFaceIdentify(data).then(res => {
                                if(res.data.code == 1000) {
                                    _this.inputVal.headImage = img
                                } else {
                                    _this.inputVal.headImage = ''
                                }
                            })
                        } else {
                            _this.inputVal.headImage = res.data.data
                        }
                    })
                    .finally(() => {
                        _this.imgLoading = false
                    })
            })
        },
        loadWorkPassImg(req) {
            var _this = this
            _this.loadImgCommon(req, (params) => {
                _this.imgLoadingWorkPass = true
                uploadImageByBaseStr(params)
                    .then(res => {
                        _this.inputVal.workPass = res.data.data
                    })
                    .finally(() => {
                        _this.imgLoadingWorkPass = false
                    })
            })
        },
        codeDisabled() {
            return this.inputVal.faxCode == '' || this.inputVal.faxCode == 86
        },
        // 发送验证码
        callback(res) {
            if (res.type !== 'sendCode') return
            let _this = this
            if (res.reg === 'phone') {
                validateMobile({
                    mobile: _this.inputVal.mobile
                })
                .then(res => {
                    if (res.data.data.repeat) {
                        _this.$notify.error(_this.$t('mobileRepeat'))
                        this.disabled = true
                    } else {
                        sendPhoneCode({ mobile: _this.inputVal.mobile })
                        .then(() => {
                            _this.$notify.success(_this.$t('The verification code has been sent'))
                        })
                        .catch(() => {
                            this.disabled = true
                        })
                        .finally(() => {
                            this.disabled = false
                        })
                    }
                })
                .catch(() => {
                    this.disabled = true
                })
                .finally(() => {
                    this.disabled = false
                })
                return false
            }

            checkEmail({
                email: this.inputVal.email
            })
            .then(res => {
                return res.data
            })
            .then(res => {
                if (!res.data.repeat) {
                    // 发送邮箱验证码
                    sendEmailCode({
                        email: _this.inputVal.email
                    }).then(() => {
                        // setToken(res.headers.authorization)
                        _this.$notify.success(_this.$t('The verification code has been sent'))
                    })
                    .catch(() => {
                        this.disabled = true
                    })
                    .finally(() => {
                        this.disabled = false
                    })
                } else {
                    _this.$notify.error(_this.$t('Email already exist'))
                    this.disabled = true
                }
            })
            .catch(() => {
                this.disabled = true
            })
            .finally(() => {
                this.disabled = false
            })
        }
    }
}
export default registerMixin